import { useNavigate, Outlet, Link, useLocation } from "react-router-dom";
import skyBackground from "../../images/laptop_sky.png";
import skyBackgroundCell from "../../images/cellphone_sky.png";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import { MenuStyles, HeaderStyles, NavStyles } from "styles/style";
import { ReactComponent as UserIcon } from "feather-icons/dist/icons/user.svg";
import Footer from "components/base/Footer";


export default function HomeMenu ({
    menu = [],
    bgImage = window.innerWidth >= 640 ? skyBackground : skyBackgroundCell
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const isExactHome = location.pathname === '/home';

    return (
        <>
        <Outlet />
        {isExactHome && (
            <AnimationRevealPage>
            <MenuStyles.HomeContainer background={bgImage}>
                <MenuStyles.HeroContainer>
                    <HeaderStyles.StyledHeader
                        links={[
                            <NavStyles.NavLinks key={2}>
		                    	<MenuStyles.ProfileButton onClick={()=> navigate("/profile")}>
		                    		<UserIcon tw="w-6 h-6 mr-2" /> {"Profile"}
		                    	</MenuStyles.ProfileButton>
		                    </NavStyles.NavLinks>
                        ]}
                        />
                    <MenuStyles.MenuContent>
                        <MenuStyles.MenuGrid>
                            { menu && menu.map((item, index) => {
                                if (item.path === "profile") return null;
                                return (
                                    <MenuStyles.MenuPrimaryAction
                                        key={index}
                                        as={Link}
                                        to={`/${item.path}`}
                                    >
                                        { item.title.toUpperCase() }
                                    </MenuStyles.MenuPrimaryAction>
                                )
                            }) }
                        </MenuStyles.MenuGrid>
                    </MenuStyles.MenuContent>
                    <Footer tw="mb-8" />
                </MenuStyles.HeroContainer>
            </MenuStyles.HomeContainer>
            </AnimationRevealPage>
        )}
        </>
    )
};